<template>
  <div class="wrapper">
    <side-bar title="Rubinot Data">
      <template slot="links">
        <sidebar-link to="/dashboard" name="Início" icon="ti-home" />
        <sidebar-link to="/cotacao" name="Cotação" icon="ti-search" />
        <sidebar-link to="/mundos" name="Mundos" icon="ti-world" />
        <sidebar-link to="/comparador" name="Comparador" icon="ti-layout-list-thumb-alt" />
        <sidebar-link to="/varinhas" name="Varinhas" icon="ti-cup" />
        <sidebar-link to="/sobre" name="Sobre" icon="ti-info-alt" />
      </template>
      <mobile-menu>
        <li class="nav-item">
          <a class="nav-link" href="/dashboard">
            <i class="ti-home"></i>
            <p>Início</p>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/cotacao">
            <i class="ti-search"></i>
            <p>Cotação</p>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/mundos">
            <i class="ti-world"></i>
            <p>Mundos</p>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/comparador">
            <i class="ti-layout-list-thumb-alt"></i>
            <p>Comparador</p>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/varinhas">
            <i class="ti-cup"></i>
            <p>Varinhas</p>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/sobre">
            <i class="ti-info-alt"></i>
            <p>Sobre</p>
          </a>
        </li>
      </mobile-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>
      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
